export default __webpack_public_path__ + "how-to.86bb6d.jpg";